import React from 'react';
import { TripDetails } from '../../types/trip-details';

function time(value?: string | null) {
  if (!value) return 'Not recorded';
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime())
    ? 'Not recorded'
    : parsed.toLocaleString();
}
export default function TripPlanSummary({
  value,
  operatorNotes = false,
}: {
  value: TripDetails;
  operatorNotes?: boolean;
}) {
  const hasDetails =
    value.passenger_count ||
    value.segments?.length ||
    value.passenger_instructions ||
    value.actual_pickup_at ||
    value.actual_dropoff_at ||
    (operatorNotes && (value.internal_notes || value.dispatch_notes));
  if (!hasDetails) return null;
  return (
    <section className="space-y-3 border-t border-outline/50 py-4">
      {value.passenger_count ? (
        <p className="text-sm font-medium">
          Passengers: {value.passenger_count}
        </p>
      ) : null}
      {value.passenger_instructions ? (
        <div>
          <h4 className="text-xs font-semibold">Passenger instructions</h4>
          <p className="whitespace-pre-wrap break-words text-sm">
            {value.passenger_instructions}
          </p>
        </div>
      ) : null}
      {value.actual_pickup_at || value.actual_dropoff_at ? (
        <dl className="grid grid-cols-1 gap-2 text-sm sm:grid-cols-2">
          <div>
            <dt className="text-xs">Actual pickup</dt>
            <dd>{time(value.actual_pickup_at)}</dd>
          </div>
          <div>
            <dt className="text-xs">Actual dropoff</dt>
            <dd>{time(value.actual_dropoff_at)}</dd>
          </div>
        </dl>
      ) : null}
      {value.segments?.map((segment) => (
        <div
          key={segment.id}
          className="space-y-2 border-t border-outline/40 pt-3"
        >
          <h4 className="text-sm font-semibold">{segment.label}</h4>
          <p className="text-xs">
            {time(segment.start_at)} to {time(segment.end_at)} ·{' '}
            {segment.timezone}
            {segment.passenger_count
              ? ` · ${segment.passenger_count} passengers`
              : ''}
          </p>
          <ol className="space-y-2 text-sm">
            {segment.stops.map((stop) => (
              <li key={stop.id}>
                <span className="font-medium">{stop.label}</span>:{' '}
                {stop.address?.formatted ||
                  stop.address?.line1 ||
                  stop.address?.name}
                {stop.passenger_instructions ? (
                  <p className="whitespace-pre-wrap break-words">
                    {stop.passenger_instructions}
                  </p>
                ) : null}
              </li>
            ))}
          </ol>
          {segment.passenger_instructions ? (
            <p className="whitespace-pre-wrap break-words text-sm">
              {segment.passenger_instructions}
            </p>
          ) : null}
        </div>
      ))}
      {operatorNotes ? (
        <>
          {value.dispatch_notes ? (
            <div>
              <h4 className="text-xs font-semibold">Dispatch notes</h4>
              <p className="whitespace-pre-wrap break-words text-sm">
                {value.dispatch_notes}
              </p>
            </div>
          ) : null}
          {value.internal_notes ? (
            <div>
              <h4 className="text-xs font-semibold">Operator internal notes</h4>
              <p className="whitespace-pre-wrap break-words text-sm">
                {value.internal_notes}
              </p>
            </div>
          ) : null}
        </>
      ) : null}
    </section>
  );
}
